// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_resource_owner.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AppResourceOwnersSearch } from "./app_resource_owner";
import type { SearchAppResourceOwnersResponse } from "./app_resource_owner";
import type { SearchAppResourceOwnersRequest } from "./app_resource_owner";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppResourceOwners } from "./app_resource_owner";
import type { DeleteAppResourceOwnersResponse } from "./app_resource_owner";
import type { DeleteAppResourceOwnersRequest } from "./app_resource_owner";
import type { RemoveAppResourceOwnerResponse } from "./app_resource_owner";
import type { RemoveAppResourceOwnerRequest } from "./app_resource_owner";
import type { AddAppResourceOwnerResponse } from "./app_resource_owner";
import type { AddAppResourceOwnerRequest } from "./app_resource_owner";
import type { SetAppResourceOwnersResponse } from "./app_resource_owner";
import type { SetAppResourceOwnersRequest } from "./app_resource_owner";
import type { ListAppResourceOwnerIDsResponse } from "./app_resource_owner";
import type { ListAppResourceOwnerIDsRequest } from "./app_resource_owner";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ListAppResourceOwnersResponse } from "./app_resource_owner";
import type { ListAppResourceOwnersRequest } from "./app_resource_owner";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.AppResourceOwners
 */
export interface IAppResourceOwnersClient {
    /**
     * List all owners of an app resource.
     *
     * @generated from protobuf rpc: List
     */
    list(input: ListAppResourceOwnersRequest, options?: RpcOptions): UnaryCall<ListAppResourceOwnersRequest, ListAppResourceOwnersResponse>;
    /**
     * ListOwnerIDs lists owner IDs for a given app resource.
     *
     * @generated from protobuf rpc: ListOwnerIDs
     */
    listOwnerIDs(input: ListAppResourceOwnerIDsRequest, options?: RpcOptions): UnaryCall<ListAppResourceOwnerIDsRequest, ListAppResourceOwnerIDsResponse>;
    /**
     * Sets the owners for a given app resource to the specified list of users.
     *
     * @generated from protobuf rpc: Set
     */
    set(input: SetAppResourceOwnersRequest, options?: RpcOptions): UnaryCall<SetAppResourceOwnersRequest, SetAppResourceOwnersResponse>;
    /**
     * @generated from protobuf rpc: Add
     */
    add(input: AddAppResourceOwnerRequest, options?: RpcOptions): UnaryCall<AddAppResourceOwnerRequest, AddAppResourceOwnerResponse>;
    /**
     * @generated from protobuf rpc: Remove
     */
    remove(input: RemoveAppResourceOwnerRequest, options?: RpcOptions): UnaryCall<RemoveAppResourceOwnerRequest, RemoveAppResourceOwnerResponse>;
    /**
     * Delete deletes the owners from a given app resource.
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeleteAppResourceOwnersRequest, options?: RpcOptions): UnaryCall<DeleteAppResourceOwnersRequest, DeleteAppResourceOwnersResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppResourceOwners
 */
export class AppResourceOwnersClient implements IAppResourceOwnersClient, ServiceInfo {
    typeName = AppResourceOwners.typeName;
    methods = AppResourceOwners.methods;
    options = AppResourceOwners.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * List all owners of an app resource.
     *
     * @generated from protobuf rpc: List
     */
    list(input: ListAppResourceOwnersRequest, options?: RpcOptions): UnaryCall<ListAppResourceOwnersRequest, ListAppResourceOwnersResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppResourceOwnersRequest, ListAppResourceOwnersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListOwnerIDs lists owner IDs for a given app resource.
     *
     * @generated from protobuf rpc: ListOwnerIDs
     */
    listOwnerIDs(input: ListAppResourceOwnerIDsRequest, options?: RpcOptions): UnaryCall<ListAppResourceOwnerIDsRequest, ListAppResourceOwnerIDsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppResourceOwnerIDsRequest, ListAppResourceOwnerIDsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Sets the owners for a given app resource to the specified list of users.
     *
     * @generated from protobuf rpc: Set
     */
    set(input: SetAppResourceOwnersRequest, options?: RpcOptions): UnaryCall<SetAppResourceOwnersRequest, SetAppResourceOwnersResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetAppResourceOwnersRequest, SetAppResourceOwnersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Add
     */
    add(input: AddAppResourceOwnerRequest, options?: RpcOptions): UnaryCall<AddAppResourceOwnerRequest, AddAppResourceOwnerResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddAppResourceOwnerRequest, AddAppResourceOwnerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Remove
     */
    remove(input: RemoveAppResourceOwnerRequest, options?: RpcOptions): UnaryCall<RemoveAppResourceOwnerRequest, RemoveAppResourceOwnerResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveAppResourceOwnerRequest, RemoveAppResourceOwnerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete deletes the owners from a given app resource.
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeleteAppResourceOwnersRequest, options?: RpcOptions): UnaryCall<DeleteAppResourceOwnersRequest, DeleteAppResourceOwnersResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAppResourceOwnersRequest, DeleteAppResourceOwnersResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.app.v1.AppResourceOwnersSearch
 */
export interface IAppResourceOwnersSearchClient {
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: SearchAppResourceOwnersRequest, options?: RpcOptions): UnaryCall<SearchAppResourceOwnersRequest, SearchAppResourceOwnersResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppResourceOwnersSearch
 */
export class AppResourceOwnersSearchClient implements IAppResourceOwnersSearchClient, ServiceInfo {
    typeName = AppResourceOwnersSearch.typeName;
    methods = AppResourceOwnersSearch.methods;
    options = AppResourceOwnersSearch.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: SearchAppResourceOwnersRequest, options?: RpcOptions): UnaryCall<SearchAppResourceOwnersRequest, SearchAppResourceOwnersResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourceOwnersRequest, SearchAppResourceOwnersResponse>("unary", this._transport, method, opt, input);
    }
}
